(function($) {
    class W4D_Helper {
        constructor() {
            this.initSelectors()
            this.bindEvents();
        }

        initSelectors() {
            this.productCards = $('.product-cards');
            this.productCard = '.product-card';

            this.spinner = $('spinner');

            // Filters and Sort
            this.filtersExpandAndClearContainer = $('.filters__expand-and-clear');
            this.expandFiltersBtn = $('.filters__expand-btn');
            this.filtersWrapper = $('.filters__wrapper');
        }

        bindEvents() {
            this.productCards.on('click', this.productCard, (e) => this.handleProductCardClick(e));
            this.expandFiltersBtn.on('click', (e) => this.handleExpandFiltersBtnClick(e));
        }

        handleExpandFiltersBtnClick() {
            this.filtersWrapper.toggleClass('filters__wrapper--expanded');
            this.filtersExpandAndClearContainer.toggleClass('filters__expand-and-clear--expanded');

            const isExpanded = this.filtersExpandAndClearContainer.hasClass('filters__expand-and-clear--expanded');

            this.expandFiltersBtn.html(
                isExpanded
                    ? 'Manje filtera <i class="icon-chevron-up"></i>'
                    : 'Više filtera <i class="icon-chevron-down"></i>'
            );
        }

        handleProductCardClick(e) {
            if (e.target !== e.currentTarget &&
                (e.target.classList.contains('favourite') ||
                    e.target.classList.contains('product-card__add-to-card'))) {
                return;
            }

            const productLink = $(e.currentTarget).data('product-link');
            if (productLink) {
                window.location.href = productLink;
            }
        }
    }

    $(document).ready(function() {
        window.W4D_Helper = new W4D_Helper();
    });
})(jQuery);